import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Ingreso Manual',
    path: `/${CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_LISTA}`
  },
  {
    name: 'Nuevo'
  }
]

const NuevoSaldoInicial = ({ history }) => {
  return (
    <Portlet>
      <Portlet.Header title='Ingreso Manual' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm history={history} />
      </Portlet.Body>
    </Portlet>
  )
}

export default NuevoSaldoInicial
